import React from "react";
import "./Pagination.css";
import { Tooltip } from "antd";

const getVisiblePages = (currentPage, totalPages) => {
    if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 2) {
        return [1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages];
    }

    if (currentPage === 3) {
        return [2, 3, 4, "...", totalPages - 2, totalPages - 1, totalPages];
    }

    if (currentPage >= totalPages - 2) {
        return [totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages - 2,
        totalPages - 1,
        totalPages,
    ];
};

export default function Pagination({
    currentPage,
    totalCount,
    pageSize,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [5, 10, 20, 50, 100],
}) {
    const totalPages = Math.ceil(totalCount / pageSize) || 1;
    const visiblePages = getVisiblePages(currentPage, totalPages);

    const startRecord = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const endRecord = Math.min(currentPage * pageSize, totalCount);

    return (
        <div className="premium-pagination-wrap">
            <div className="pagination-summary">
                Showing <strong>{startRecord}</strong> to <strong>{endRecord}</strong> of{" "}
                <strong>{totalCount}</strong> records
            </div>

            <div className="pagination-controls">
                <Tooltip title="Records per page">
                    <div className="page-size-box">
                        <span>Show</span>
                        <select
                            value={pageSize}
                            onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        >
                            {pageSizeOptions.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                </Tooltip>

                <Tooltip title="First page">
                    <button
                        type="button"
                        className="page-btn"
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(1)}
                    >
                        <i className="bi bi-chevron-double-left"></i>
                    </button>
                </Tooltip>

                <Tooltip title="Previous page">
                    <button
                        type="button"
                        className="page-btn"
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                    >
                        <i className="bi bi-chevron-left"></i>
                    </button>
                </Tooltip>

                {visiblePages.map((page, index) =>
                    page === "..." ? (
                        <Tooltip key={`dots-${index}`} title="More pages">
                            <span className="page-dots">...</span>
                        </Tooltip>
                    ) : (
                        <Tooltip key={page} title={`Go to page ${page}`}>
                            <button
                                type="button"
                                className={`page-number ${currentPage === page ? "active" : ""}`}
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </button>
                        </Tooltip>
                    )
                )}

                <Tooltip title="Next page">
                    <button
                        type="button"
                        className="page-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                    >
                        <i className="bi bi-chevron-right"></i>
                    </button>
                </Tooltip>

                <Tooltip title="Last page">
                    <button
                        type="button"
                        className="page-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(totalPages)}
                    >
                        <i className="bi bi-chevron-double-right"></i>
                    </button>
                </Tooltip>
            </div>
        </div>
    );
}